module.exports = __webpack_public_path__ + "img/info-04.5f0ac2d4.jpg";